var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"footer-menu-item",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('select', _vm.item)}}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }